import React, { useState, useEffect } from 'react';
import { Outlet } from "react-router-dom";
import Sidebar from './sidebar/index';
import Header from './header/index';
import { Toaster } from 'react-hot-toast';

export const AdminLayout: React.FC = () => {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  useEffect(() => {
    if (isMobileMenuOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'auto';
    }
    return () => {
      document.body.style.overflow = 'auto';
    };
  }, [isMobileMenuOpen]);

  return (
    <div className="flex h-screen bg-white font-poppins overflow-hidden sm:p-3">
      <Sidebar
        isMobileOpen={isMobileMenuOpen}
        onMobileClose={() => setIsMobileMenuOpen(false)}
      />
      <div className="flex-1 flex flex-col min-w-0 overflow-hidden sm:ml-3">
        <div className="">
          <Header onMenuClick={() => setIsMobileMenuOpen(true)} />
        </div>
        <main
          className="flex-1 overflow-y-auto persoscrollbar p-2 bg-dark/40 bg-cover bg-center bg-no-repeat py-5"
          style={{ backgroundImage: `url('/assets/images/bgillustra/fonds.svg')` }}
        >
          <Outlet />

          <Toaster
            position="top-right"
            reverseOrder={false}
            gutter={8}
            toastOptions={{
              duration: 5000,
            }}
          />
        </main>
      </div>
    </div>
  );
};

export default AdminLayout;